import { render, staticRenderFns } from "./MessageInboxes.vue?vue&type=template&id=fb80453a&scoped=true&"
import script from "./MessageInboxes.vue?vue&type=script&lang=ts&"
export * from "./MessageInboxes.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInboxes.vue?vue&type=style&index=0&id=fb80453a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb80453a",
  null
  
)

export default component.exports